function getAllScreenIds(): string[] {
	// Los screen cuelgan de #app y su id empieza por dialog-
	return Array.from(document.getElementById('app')!.children)
		.filter(x => x.id.startsWith('dialog-'))
		.sortBy(x => x.id)
		.map(x => x.id);
}

function getAllDialogIds(): string[] {
	// Los dialog cuelgan directamente de body y su id empieza por dialog-
	return Array.from(document.body.children)
		.filter(x => x.id.startsWith('dialog-'))
		.sortBy(x => x.id)
		.map(x => x.id);
}


export function getAllViewIds(): string[] {
	return getAllScreenIds().concat(getAllDialogIds()).sortBy(x => x);
}

export function getParentScreen(el: Element): HTMLElement {

	if (!el) {
		throw Error(`${el} does not have a DOMNode. Maybe it's not mounted yet or its render method is returning null.`);
	}

	if (!el || !el.closest) {
		throw Error(`${el} is not a valid screen child. It does not have a closest method`);
	}

	const screen = el.closest('.screen');
	if (!screen) {
		throw Error(`${el} is not a valid screen child`);
	}

	return screen as HTMLElement;
}

// Indica si el PosScreen que contiene el elemento es el PosScreen en primer plano.
// OJO: Esto no quiere decir que sea la vista en primer plano. Podría haber un diálogo por encima.
export function isInTopScreen(screenChild: Element): boolean {
	const screenId = getParentScreen(screenChild).id;
	const allScreenIds = getAllScreenIds();
	return screenId === allScreenIds[allScreenIds.length - 1];
}

// Indica si la vista (PosScreen o Dialog) que contiene el elemento es la vista en primer plano.
export function isInTopView(screenChild: Element): boolean {
	const parentScreenId = getParentScreen(screenChild).id;
	const allViewsIds = getAllViewIds();
	return parentScreenId === allViewsIds[allViewsIds.length - 1];
}
